import React, { useEffect, useState } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import { Container, Modal, ModalContent, Wrapper } from "../style/view.styles";
import { Sidebar, SidebarContainer } from "../style/sidebar.styles";
import BackButton from "../components/Buttons/BackButton";
import InternshipApplicationForm from "../components/Elements/InternshipApplicationForm";
import { getLoggedInUser } from "../utils/AuthHandler";
import ConfirmCancelInternshipModal from "../components/Elements/ConfirmCancelInternshipModal";
import InternshipDetailsBody from "../components/Elements/InternshipDetailsBody";
import { deleteEntityInstance } from "../utils/RequestHandler";

export default function InternshipDetails() {
  const [isLoggedIn, setIsLoggedIn] = useState(false);
  const [isApplyModalOpen, setIsApplyModalOpen] = useState(false);
  const [isCancelModalOpen, setIsCancelModalOpen] = useState(false);
  const handleApplyModalClose = () => setIsApplyModalOpen(false);
  const handleCancelModalClose = () => setIsCancelModalOpen(false);
  const [formStatus, setFormStatus] = useState({ message: "", type: "" });
  const [submitting, setSubmitting] = useState(false);
  const [isApplicationSubmitted, setIsApplicationSubmitted] = useState(false);

  const navigate = useNavigate();

  const [user, setUser] = useState(null);

  useEffect(() => {
    const user = getLoggedInUser();
    setIsLoggedIn(!!user);
    setUser(user);
  }, []);

  const handleModalBackgroundClick = (e) => {
    if (e.target === e.currentTarget) {
      handleApplyModalClose();
    }
  };

  const location = useLocation();
  const internship = location.state?.internship || null;

  const handleCloseInternship = async (to_close) => {
    try {
      setSubmitting(true);

      const response = await deleteEntityInstance(
        "internships",
        to_close?.uuid
      );
      if (response.success) {
        navigate("/internships");
      } else {
        setFormStatus({
          message: response.result ?? "An error occurred. Please try again.",
          type: "error",
        });
      }
    } catch (error) {
      setFormStatus({
        message: "An error occurred while adding your opportunity.",
        type: "error",
      });
    } finally {
      setSubmitting(false);
    }
  };

  if (!internship) {
    return (
      <>
        <Wrapper className="paleBlueGreyBg">
          <div className="container">
            <p className="font18">Internship details not available.</p>
          </div>
        </Wrapper>
      </>
    );
  }

  return (
    <>
      <Wrapper className="paleBlueGreyBg">
        <Container>
          <SidebarContainer>
            <Sidebar isExpanded={true}>
              <BackButton path="/internships" />
            </Sidebar>
          </SidebarContainer>
          <InternshipDetailsBody
            internship={internship}
            isLoggedIn={isLoggedIn}
            user={user}
            setIsApplyModalOpen={setIsApplyModalOpen}
            setIsCancelModalOpen={setIsCancelModalOpen}
            isApplyModalOpen={isApplyModalOpen}
            isCancelModalOpen={isCancelModalOpen}
            isApplicationSubmitted={isApplicationSubmitted}
          />
        </Container>
      </Wrapper>
      {isApplyModalOpen && (
        <Modal onClick={handleModalBackgroundClick}>
          <ModalContent onClick={(e) => e.stopPropagation()}>
            <InternshipApplicationForm
              selectedInternship={internship}
              handleModalClose={handleApplyModalClose}
              setIsApplicationSubmitted={setIsApplicationSubmitted}
            />
          </ModalContent>
        </Modal>
      )}
      {isCancelModalOpen && (
        <ConfirmCancelInternshipModal
          selectedInternship={internship}
          handleModalClose={handleCancelModalClose}
          handleWithdraw={handleCloseInternship}
          formStatus={formStatus}
          submitting={submitting}
        />
      )}
    </>
  );
}
